import * as Types from "../constants/CompanyConstants";

export const resetCompany = () => ({
  type: Types.RESET_COMPANY
});

// FETCH COMPANIES ACTIONS
export const fetchCompanies = () => ({
  type: Types.FETCH_COMPANIES
});

export const fetchCompaniesOk = (roles) => ({
  type: Types.FETCH_COMPANIES_OK,
  payload: roles
})

export const fetchCompaniesFailed = (error) => ({
  type: Types.FETCH_COMPANIES_FAILED,
  payload: error
})

// STORE COMPANY
export const storeCompanyAction = (company) => {
  return {
    type: Types.STORE_COMPANY,
    payload: company,
  };
};

export const storeCompanyMessageAction = ({ message, error, showMessage }) => {
  return {
    type: Types.STORE_COMPANY_MESSAGE,
    message,
    error,
    showMessage: showMessage ?? true,
  };
};

export const fetchCompanyAction = (companyId) => {
  return {
    type: Types.FETCH_COMPANY,
    companyId,
  };
};
export const fetchCompanySuccessAction = ({ company, message }) => {
  return {
    type: Types.FETCH_COMPANY_SUCCESS,
    payload: { company, message },
  };
};

export const fetchCompanyErrorAction = ({ message }) => {
  return {
    type: Types.FETCH_COMPANY_ERROR,
    payload: { message },
  };
};

export const updateCompanyAction = ({ companyId, company }) => {
  return {
    type: Types.UPDATE_COMPANY,
    companyId,
    company,
  };
};
export const updateCompanySuccessAction = ({ message, company }) => {
  return {
    type: Types.UPDATE_COMPANY_SUCCESS,
    payload: { message, company },
  };
};

export const updateCompanyErrorAction = ({ message }) => {
  return {
    type: Types.UPDATE_COMPANY_ERROR,
    payload: { message },
  };
};
